import React from "react";
import { getLoggedStatus } from "../utils/helpers";
import { useAppSelector } from ".";
import { useWebFramed } from "./useWebFramed";

export const useVirtualPageView = (
  title: string,
  setDL = true,
  crsCode = "",
  city = "",
  brand = "",
  brandPage = false,
  isCheckoutPage = false
): void => {
  const isWebFramed = useWebFramed();
  const recentSearch = useAppSelector((state: any) => state.recentSearch);
  const pageUrl = typeof window !== "undefined" ? window.location.href : "/";
  const storedReferrer =
    typeof window !== "undefined"
      ? sessionStorage.getItem("previousUrl")
      : null;
  const referrer =
    isWebFramed && recentSearch?.isAbandonCart
      ? "AbandonCart"
      : storedReferrer ||
        (typeof window !== "undefined"
          ? window.document.referrer.split("?")[0]
          : null);

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const pageUrlWithoutSearchParams =
        window.location.origin + window.location.pathname;
      sessionStorage.setItem("previousUrl", pageUrlWithoutSearchParams); // Store only the base URL (without search params)
    }
  }, [pageUrl]);

  React.useEffect(() => {
    try {
      if (setDL && !isCheckoutPage) {
        window.dataLayer = window.dataLayer || [];
        const loggedState = getLoggedStatus();

        window.dataLayer.push({ page_details: null });

        const dlObj = {
          event: "virtualPageView",
          loggedState: loggedState,
          ...(crsCode && { crsCode: crsCode }),
          ...(crsCode && city && { city }),
          ...((crsCode || brandPage) && brand && { brand }),
          page_details: {
            pageUrl: pageUrl,
            pageTitle: title,
            page_referrer: referrer,
          },
        };

        window.dataLayer.push(dlObj);
      }
    } catch (err) {
      console.error(err);
    }
  }, [title, setDL, crsCode, city, brand, brandPage, pageUrl]);
};
